<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/AktywnosciSpoleczne'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}

const component_default_values_2: CmsCustomComponentType = {
  poster: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'image', setting_label: 'zmien poster' },
  video: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'video', setting_label: 'zmien video' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl py-20 flex flex-col gap-20 bg-background-1"
    >
      <div class="grid grid-cols-1 2xl:grid-cols-2 grid-rows-1 gap-16 xl:gap-50 justify-between items-center">
        <div class="flex flex-col gap-7.5">
          <span class="text-H2 text-Tekst">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
            />
          </span>
          <span class="text-H4 text-Tekst">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
            />
          </span>
        </div>
        <div class="flex flex-col gap-5 xl:gap-10 py-5 xl:py-10 px-5 xl:px-13 bg-Primary rounded-2xl">
          <div class="flex flex-col justify-center gap-3">
            <span class="text-H4 text-white text-center">
              <CmsText
                :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_3']"
              />
            </span>
            <div class="flex flex-col items-center justify-center bg-[#932B38] rounded-3xl py-2 xl:py-5 px-5 xl:px-12">
              <span class="text-H3 text-white">
                <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_4']"
                />
              </span>
            </div>
          </div>
          <CmsCustomComponentList
            v-slot="{ component_values: componentListValues }"
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'list']"
            :open-options="true"
            component-name="images_list"
            class="min-w-5 min-h-5 flex flex-col gap-2.5"
          >
            <div
              v-for="(item, index) in componentListValues"
              :key="JSON.stringify(item)"
              class="flex flex-row gap-5 items-center"
            >
              <CmsImage
                :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'image']"
                class="w-10 h-9"
              />
              <div class="border-b border-Tertiary">
                <span class="text-Paragraph text-white">
                  <CmsText
                    :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'text']"
                  />
                </span>
              </div>
            </div>
          </CmsCustomComponentList>
          <div>
            <span class="text-white text-H4">
              <CmsText
                :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_5']"
              />
            </span>
          </div>
          <CmsLink
            v-slot="{ link }"
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'link']"
          >
            <AppButton
              button-theme="Background-2"
              :href="link?.href"
              :target="link?.target"
            >
              <span class="link-text">{{ link?.link_text ?? 'Lorem Ipsum' }}</span>
            </AppButton>
          </CmsLink>
        </div>
      </div>

      <CmsCustomComponentList
        v-slot="{ component_values: componentListValues }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_akt_akt']"
        :defaults="component_default_values_2"
        :open-options="true"
        component-name="list_akt_akt"
      >
        <AktualnoscCardSliderComponent
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_akt_akt', 'component_data']"
          :data-length="componentListValues.length"
          :data="componentListValues"
        />
      </CmsCustomComponentList>
    </div>
  </CmsCustomComponent>
</template>
